import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatTabGroup } from '@angular/material/tabs';
import { CompanyDetail } from '@classes/company-detail';
import { CustomerGridViewItem } from '@classes/customer-grid-view-item';
import { CustomerGridComponent } from '../../components/customer-grid/customer-grid.component';

@Component({
  selector: 'app-customer',
  templateUrl: './customer.component.html',
  styleUrls: ['./customer.component.scss'],
  styles: [`
  >>> app-customer {
    height: 100%;
    display: flex;
  }
`]
})
export class CustomerComponent implements OnInit {

  customerForm: FormGroup;
  companyDetail: CompanyDetail;

  @ViewChild('CustomerGridComponent') customerGridComponent: CustomerGridComponent;
  @ViewChild("CustomerMatTabGroup", { static: false }) customerMatTabGroup: MatTabGroup;

  constructor(
    private formBuilder: FormBuilder
  ) { }

  ngOnInit() {
  }

  loadCompanyDetail(event: any) {
    this.companyDetail = event;
  }
  loadContract(event: any) {
    this.customerMatTabGroup.selectedIndex = 1;
    this.companyDetail = event;
  }
  backToCustomer(){
    this.customerMatTabGroup.selectedIndex = 0;
  }

  refreshGrid() {
    this.customerGridComponent.getCustomers();
  }

  refreshCompany() {
    this.customerGridComponent.selectItemClick(
      new CustomerGridViewItem({
        id: this.companyDetail.company?.id
      })
    );
  }
}
